import React, { useState } from 'react';
import { isValidEmail } from '../../hooks/useValidation';
import { landJoinUrl } from '../../providers/EnvContextProvider';
import LandLine from './LandLine';
import { Link } from 'react-router-dom';
import './LandJoinForm.css'

const LandJoinForm = ({withTags=true, cta='Join Now'}) => {

  const [email, setEmail] = useState('');
  const [errorInfo,setErrorInfo]      = useState('Please enter a valid email address');
  const [showError, setShowError]     = useState(false);
  const [signUpDone, setSignUpDone]   = useState(); // {username:'moshe+avdiel@gmail.com.edu', passwd: 'blablu-2454-bling-done-23'}

  const padTop = withTags ? 64 : 8;

  const onEmailChanged = (e) => {
    setShowError(false);
    const text = e.target.value;
    setEmail(text);
    
    if (isValidEmail(text, true)) {
      setErrorInfo('');
    }
    else {
      setErrorInfo('Please enter a valid email');
    }
  }

  // Land SignUp
  //
  const handleLandSignUp = () => {
    console.log('handleSignUp  Error:',errorInfo);
    
    if (errorInfo !== '') {
      setShowError(true);
      return;
    }

    const code = Array.from(crypto.getRandomValues(new Uint8Array(6))).map(b => (b % 36).toString(36)).join('');
    const accName = 'my-account-'+code;

    fetch(landJoinUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'landAccountName': accName,
        //'accountPlan': 'teamPro',
        'landUsername': email,
        'landEmail': email,
        'campId': 'land-001'
        // 'userPhone': '',
        // 'firstName': 'Friend',
        // 'midName':'',
        // 'lastName':''
      })
    }).then(resp => {
      if (resp.ok) {
        // Google Ads: Conversion Event on Successful SignUp
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17189270506/Fjv5CIeWzdgaEOrnvYRA',
          'value': 1.0,
          'currency': 'ILS',
          'transaction_id': ''
        });

        resp.json().then(doneData => setSignUpDone(doneData));
      }
      else {
        // ... Error 
        console.error('Error SignUp');
      }
    })
  }


  return (
    <div className='landJoinForm' style={{paddingTop: padTop, paddingLeft: padTop, paddingRight: padTop}}>
        <div className='inputTitle'>
          {showError && <div>{errorInfo}</div>}
        </div>
        <input className='landInput' type='text' onChange={onEmailChanged} placeholder='Your email'/>
        <button className='joinNowButton' onClick={handleLandSignUp} style={{marginTop: 0}}>{cta}</button>

        {withTags &&  <hr/>}
        {withTags &&  <ul>
          <li>WebSocket Based SDK</li>
          <li>WebSocket based Web Admin</li>
          <li>SSL, WSS, JWT Id+Access</li>
          <li>Role Based Access - Per Team!</li>
          <li>Highly Encrypted Vault</li>
          <li>No Restarts, Redeploy, Reload</li>
          <li>No Refresh - Everything is Instant!</li>
        </ul>}


        {signUpDone?.username && <div className='landSignUpDone'>
            <div className='landDoneWelcome'>
              Welcome!
            </div>
            <div style={{ fontSize: 14, marginTop: 24, marginBottom: 32}}>Please save your username and password</div>

            <LandLine title='Username' value={signUpDone.username} />
            <LandLine title='Password' value={signUpDone.passwd} />

            <div className='landLogin'>
              <Link to='/login'>I'm Ready To Login</Link>
            </div>
          </div>}        

    </div>
  );
};

export default LandJoinForm;